var generalOptions = {}
var graphics = {};

"use strict";
$(document).foundation();
(function ($, window) {
    var LRGraphGeneral = function (a) {};
    LRGraphGeneral.prototype = {
        initialize: function () {
            generalOptions = {
                color: ['#4872b8'],
                title: {
                    show: false
                },
                grid: {
                    left: '0',
                    right: '0',
                    bottom: '40',
                    top: '40'
                },
                legend: {
                    show: false
                },
                xAxis: {
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    },
                    splitLine: {
                        show: true,
                        interval: 'auto'
                    },
                    interval: 5,
                    inverse: true
                },
                yAxis: {
                    show: false,
                    scale: true,
                }
            };
            this.initEvents();
        },
        resizeGraphs: function () {      
            for (var graph in graphics) {
                graphics[graph].resize();
            }
        },
        initEvents: function () {
            $(window).resize(this.resizeGraphs);
        },
        format: function (data, style, decimals) {
            data = parseFloat(data);
            var opts = {
                style: style,
                maximumFractionDigits: decimals
            }
            if (style === 'currency') {
                opts.currency = 'COP';
            }
            return data.toLocaleString('es-CO', opts);
        }
    };
    window.LRGraphGeneral = new LRGraphGeneral();
    window.LRGraphGeneral.initialize();
})(jQuery, this, this.document, undefined);